<template>
    <div>
        <div class="vx-row">
            <vx-card title="Edit MID" class="mb-4 pb-5">
                <!-- Merchant  -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>Merchant</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <v-select required v-model="selected_merchant" :options="merchant_list" name="Merchant"
                            placeholder="Please Select Merchant" v-validate="'required'">
                        </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('Merchant')">{{
                            errors.first('Merchant')
                        }}
                        </span>

                    </div>
                </div>

                <!--Payment Channel -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>Payment Channel</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <v-select required id="Payment Channel" v-model="selected_payment_channel"
                            placeholder="Please Select Payment Channel" name="Payment Channel"
                            :options="payment_channel_list" v-validate="'required'">
                        </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('Payment Channel')">{{
                            errors.first('Payment Channel')
                        }}</span>
                    </div>
                </div>

                <!-- MID Input -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>MID</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <vs-input class="w-full" v-model.trim="mid" placeholder="Please Fill MID Code"
                            v-validate="{ required: true, regex: /(^[a-zA-Z0-9]{15}$)|(^^[a-zA-Z0-9]{16}$)/ }"
                            name="MID Code" @input="(val) => (mid = mid.toUpperCase())" />
                        <span class="text-danger text-sm" v-show="errors.has('MID Code')">{{
                            errors.first('MID Code')
                        }}</span>
                    </div>
                </div>

                <!-- Is Active -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>Is Activated</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <input type="radio" value=true v-model="isActive"> Yes
                        <input type="radio" value=false v-model="isActive"> No
                    </div>
                </div>

                <!-- action button -->
                <div class="w-full text-right  p-4">
                    <vs-button id="btn-cancel" color="warning" @click="backPage">Cancel</vs-button>
                    <vs-button id="btn-submit" class="ml-4" @click.prevent="showConfirmDialog">Submit</vs-button>
                    <vs-popup title="Are you sure with this data?" :active.sync="popupActivo">
                        Before : <br />
                        Merchant Code : <b>{{ this.$route.params.currentmid.merchant_code }}</b><br />
                        Merchant Name : <b>{{ this.$route.params.currentmid.merchant_name }}</b><br />
                        Payment Channel Code : <b>{{ this.$route.params.currentmid.payment_channel_code }}</b><br />
                        Payment Channel Name : <b>{{ this.$route.params.currentmid.payment_channel_name }}</b><br />
                        MID Code : <b>{{ this.$route.params.currentmid.mid_code }}</b><br />
                        Is Actvie : <b>{{ this.$route.params.currentmid.is_active }}</b><br />
                        <br />
                        After : <br />
                        Merchant Code : <b>{{ this.selected_merchant.code }}</b><br />
                        Merchant Name : <b>{{ this.selected_merchant.label }}</b><br />
                        Payment Channel Code : <b>{{ this.selected_payment_channel.payment_code }}</b><br />
                        Payment Channel Name : <b>{{ this.selected_payment_channel.label }}</b><br />
                        MID Code : <b>{{ this.mid }}</b><br />
                        Is Active : <b>{{ this.isActive }}</b><br />
                        <div class="w-full text-right">
                            <vs-button id="btn-submit" class="mt-5 ml-4" @click.prevent="submitForm">Submit</vs-button>
                        </div>
                    </vs-popup>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import AxiosCall from "@/global/AxiosCall";
import { url } from "@/configs/apiUrl";
import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css'
import swal from "sweetalert2";

export default {
    name: "EditMID",
    components: {
        'v-select': vSelect,
        VueSimpleSuggest
    },
    data() {
        return {
            merchant_list: [],
            selected_merchant: [],
            payment_channel_list: [],
            selected_payment_channel: [],
            mid: '',
            isActive: '',
            popupActivo: false,

        }
    },
    watch: {

    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        // begin 
        backPage() {
            this.$router.push({ name: 'TIDAndMIDManagement' })
        },
        showConfirmDialog() {
            this.$validator.validateAll()
                .then((res) => {
                    if (res) {
                        this.popupActivo = true;
                    }
                })
        },
        submitForm() {
            this.$validator.validateAll()
                .then((res) => {
                    this.popupActivo = false;
                    if (res) {
                        let payload = {
                            merchant_id: this.selected_merchant.merchant_id,
                            merchant_code: this.selected_merchant.code,
                            merchant_name: this.selected_merchant.label,
                            payment_channel_id: this.selected_payment_channel.payment_id,
                            payment_channel_code: this.selected_payment_channel.payment_code,
                            payment_channel_name: this.selected_payment_channel.label,
                            mid_code: this.mid,
                            is_active: this.isActive
                        }
                        AxiosCall.Put(url.svd.mid.update + this.$route.params.id, payload)
                            .then((res) => {
                                if (res.message_code === 'E_INVALID_PARAMETER') {
                                    swal.fire({
                                        type: 'warning',
                                        title: 'Warning',
                                        text: res.message,
                                        allowOutsideClick: false,
                                    })
                                } else if (res.message_code === '2003') {
                                    let status = true
                                    this.$router.push({ name: "TIDAndMIDManagement", params: { status: status, message: " Succes Update MID Data " } })
                                }
                            }, (error) => {
                                swal.fire({
                                    type: 'warning',
                                    title: 'Warning',
                                    text: error.response.data.message,
                                    allowOutsideClick: false,
                                })
                            })
                    }
                })
        }
    },
    mounted() {
        if (this.$route.params.id === undefined) {
            location.href = "/tid-and-mid-management"
        } else {
            // initial value for pto merchant
            this.selected_merchant = {
                label: this.$route.params.currentmid.merchant_name,
                code: this.$route.params.currentmid.merchant_code,
                merchant_id: this.$route.params.currentmid.merchant_id,
            }
            this.selected_payment_channel = {
                label: this.$route.params.currentmid.payment_channel_name,
                payment_code: this.$route.params.currentmid.payment_channel_code,
                payment_id: this.$route.params.currentmid.payment_channel_id
            }

            this.mid = this.$route.params.currentmid.mid_code
            this.isActive = this.$route.params.currentmid.is_active
        }

        // get merchant list
        AxiosCall.Get(url.svd.merchant.combo).then(resp => {
            for (let data of resp.data) {
                if (data.depth > 2) {
                    this.merchant_list.push({
                        label: data.full_name,
                        code: data.code,
                        merchant_id: data.id
                    })
                }
            }
        })

        // get payment channel list
        AxiosCall.Get(url.svd.payment_channel.combo).then(resp => {
            for (let data of resp.data) {
                this.payment_channel_list.push({
                    label: data.name,
                    payment_code: data.code,
                    payment_id: data.id
                })
            }
        })


    }
}
</script>

<style>
.con-vs-popup .vs-popup {
    width: auto !important;
    height: auto !important;
}
</style>
